// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const RadioGroupContract = contract({
  name: "RadioGroup",
  description: "A small set of mutually-exclusive options where the user needs to SEE all of them at once — pricing tiers (3-4 options), shipping speed, payment method radio cards. When each option should be a whole clickable card (label + description, selected state on the card), use RadioCard inside the RadioGroup instead of a Card with a radio in the corner. For a plain label + description row, wrap RadioGroupItem in Field. For 5+ options use Select. For a segmented control as part of a toolbar use ToggleGroup. For yes/no use Switch.",
  import: "@gradeui/ui",
  aliases: ["radio group","radio buttons","single-choice","pricing options","payment method","radio buttons","radio control","single-select"],
  subcomponents: ["RadioGroupItem"],
  element: "div",
  composesWith: ["Label (paired with each item via htmlFor)","Field (label + description row)","RadioCard (whole-card selectable option)","Stack (vertical list)"],
  styleDefaults: {"RadioGroup":"grid gap-3"},
  props: {
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "controlled selection",
  },
  "defaultValue": {
      schema: z.string().optional(),
      design: "content",
      description: "uncontrolled initial",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "orientation": {
      schema: z.enum(["horizontal", "vertical"]).optional(),
      design: "knob",
      default: "vertical",
  },
  "name": {
      schema: z.string().optional(),
      design: "content",
      description: "form name when posting natively",
  },
  "id": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "pair with a <Label htmlFor> for click-on-label",
  },
  },
});
